import { FC, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";

import { IColumnProps } from "../../../../interfaces/tables";
import { ICoverLetter } from "../../../../interfaces/services";

import DataTable from "../../tables/DataTable";
import Drawer from "../resume/Drawer";
import { PDFViewer } from "../../../wrappers/PDFViewer";
import { useGetCareersMedia } from "../../../../hooks/misc";
import SkeletonLoader from "../../../reusables/SkeletonLoader";
import { Icons } from "../../../../data/Assets";

interface ICoverLetterViewProps {
  goBackRoute: string | null;
  linked: boolean;
  coverLetters: ICoverLetter[];
  isLoading: boolean;
}

const CoverLetterView: FC<ICoverLetterViewProps> = (props: ICoverLetterViewProps) => {
  const { coverLetters, isLoading } = props;
  const navigate = useNavigate()
  const { studentId: studentIdParam } = useParams();

  const studentId = studentIdParam ? parseInt(studentIdParam) : 0;

  const [isDrawerOpen, setIsDrawerOpen] = useState(false);
  const [selectedCoverLetter, setSelectedCoverLetter] = useState<ICoverLetter | null>(null);
  const [pdfUrl, setPdfUrl] = useState<string | null>(null);
  const { data: media, isLoading: isMediaLoading } = useGetCareersMedia(studentId, selectedCoverLetter?.medias?.[0]?.id ?? 0)


  const columns: IColumnProps[] = [
    { name: "Cover Letter Title", identifier: "coverLetterTitle" },
    { name: "Job Title", identifier: "jobTitle" },
    { name: "Date", identifier: "date" },
    // { name: "Results", identifier: "results" },
    // { name: "Reviewed by", identifier: "reviewedBy" },
  ];

  const coverLetterList = coverLetters.map((coverLetter, index) => ({
    id: coverLetter.id,
    studentId: studentId,
    coverLetterTitle: coverLetter.title || `Cover Letter ${index + 1}`,
    jobTitle: coverLetter.job_title,
    date: coverLetter.created_at,
  }));

  const handlePreviewClick = (id: number, studentId: number) => {
    const coverLetter = coverLetters.find(coverLetter => coverLetter.id === id);
    if (coverLetter) {
      setSelectedCoverLetter(coverLetter);
      setPdfUrl(media?.url ?? null);
      setIsDrawerOpen(true);
    }
  };

  return (
    <div className="immersion__student__resume__scanner__page_view">
      {/* <div className="immersion__student__resume__scanner_section">
        <div className="immersion__student__resume__scanner_section_left">
         Left section if needed
        </div>
        <div className="immersion__student__resume__scanner_section_right">
          <button className="immersion__btn immersion__btn_outline">
            <SVGIcon src={Icons.UploadOutline} color="primary" />
            <span>Upload</span>
          </button>
        </div>
      </div > */}
      <DataTable
        columns={columns}
        list={coverLetterList}
        isLoading={isLoading}
        titleIdentifier="coverLetterTitle"
        onCellClick={handlePreviewClick}
        onTitleClick={(id) => navigate(`/students/${studentId}/cover-letter/${id}`)}
      />
      {/* {selectedCoverLetter && pdfUrl && (
        <Drawer
          isOpen={isDrawerOpen}
          onClose={() => setIsDrawerOpen(false)}
          title={selectedCoverLetter?.title || "Cover Letter Preview"}
        >
          {isMediaLoading ? (
            <Loader type="normal" text="Loading PDF..." />
          ) : (
            <PDFViewer signedUrl={pdfUrl ?? ""} scale={1} />
          )}
        </Drawer>
      )} */}

      {selectedCoverLetter &&
        <Drawer
          isOpen={isDrawerOpen}
          onClose={() => setIsDrawerOpen(false)}
          title={selectedCoverLetter?.title || "Cover Letter Preview"}
          closeIcon={Icons.X}
        >
          {isMediaLoading || !pdfUrl ? (
            <SkeletonLoader type="image" />
          ) : (
            <PDFViewer signedUrl={pdfUrl ?? ""} scale={1} />
          )}
        </Drawer>
      }
    </div >
  );
};
export default CoverLetterView;